import { DownloadOutlined } from "@ant-design/icons";
import { Card, Table, Pagination, Typography, Button, Tag, Grid } from "antd";
import dayjs from "dayjs";

const { Title } = Typography;

const formatCurrency = (value) => {
  if (value) {
    return `₹${value.toLocaleString("en-IN")}`;
  }
};

const formatPercentage = (value) => {
  return value === 0 ? "-" : `${value}%`;
};

const SalesTransactionsTable = ({
  payments,
  pagination,
  currentPage,
  pageSize,
  onPageChange,
  onDownloadCSV,
  selectedAnalyticsTypes
}) => {
  const screens = Grid.useBreakpoint();
  const isMobileView = screens.md === false;

  let columns = [
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "date",
      render: (text) => dayjs(text).format("DD-MM-YYYY")
    },
    {
      title: "Time",
      dataIndex: "createdAt",
      key: "time",
      render: (text) => dayjs(text).format("HH:mm")
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      ellipsis: true
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber"
    },
    {
      title: "Amount",
      dataIndex: "amountCollected",
      key: "amountCollected",
      render: (text) => formatCurrency(text)
    },
    {
      title: "Courses",
      dataIndex: "coursesBought",
      key: "coursesBought",
      render: (courses) => courses.join(", ")
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "REFUNDED" ? "red" : "green"}>
          {status}
        </Tag>
      )
    }
  ];

  if (
    !(
      selectedAnalyticsTypes.length === 1 &&
      selectedAnalyticsTypes.includes("DOUBT_SUPPORT_EXTENSION_PURCHASE")
    )
  ) {
    columns.push(
      {
        title: "Coupon",
        dataIndex: "couponCode",
        key: "couponCode"
      },
      {
        title: "Quoted Discount %",
        dataIndex: "quotedDiscountPercentage",
        key: "quotedDiscountPercentage",
        render: (text) => formatPercentage(text)
      },
      {
        title: "Actual Discount %",
        dataIndex: "actualDiscountPercentage",
        key: "actualDiscountPercentage",
        render: (text) => formatPercentage(text)
      },
      {
        title: "Bundling Discount %",
        dataIndex: "bundlingDiscountPercentage",
        key: "bundlingDiscountPercentage",
        render: (text) => formatPercentage(text)
      },
      {
        title: "Effective Discount %",
        dataIndex: "effectiveDiscountPercentage",
        key: "effectiveDiscountPercentage",
        render: (text) => formatPercentage(text)
      }
    );
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "10px",
          marginBottom: "16px"
        }}
      >
        <Title level={3}>Payment Transactions</Title>
        <Button type="primary" icon={<DownloadOutlined />} onClick={onDownloadCSV}>
          Download CSV
        </Button>
      </div>
      <Card style={{ marginBottom: "20px" }}>
        <Table
          columns={columns}
          dataSource={payments}
          rowKey={(record, index) => index}
          pagination={false}
          scroll={{ x: "max-content" }}
        />
        <div
          style={{
            marginTop: "16px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            gap: 8
          }}
        >
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={pagination.totalItems}
            onChange={onPageChange}
            showSizeChanger={!isMobileView}
            size={isMobileView ? "small" : "default"}
            showTotal={
              isMobileView
                ? undefined
                : (total, range) => `${range[0]}-${range[1]} of ${total} items`
            }
          />
        </div>
      </Card>
    </>
  );
};

export default SalesTransactionsTable;
